import { Card, Stack } from "@mui/material";

import ShiftDetails from "../ShiftDetails";
import { ShiftItemFragment } from "./fragments.generated";

type Props = {
    shift: ShiftItemFragment;
};

export default function ShiftItem({ shift }: Props) {
    return (
        <Card variant="outlined" component={Stack} direction="column" spacing={2} sx={{ width: "100%" }}>
            <ShiftDetails shift={shift} />
        </Card>
    );
}
